import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { colors, spacing } from 'ui/theme';
import { InputField, TextAreaField } from 'lib/iterable-hook-form';
import { SAML_DOMAIN, SAML_LABELS, SAML_METADATA } from '../constants';

export const GreyContainer = styled.div`
  background-color: ${colors.grey1};
  border: solid 1px ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${spacing.plusHalf};
`;

export const SSOFields = () => (
  <GreyContainer>
    <FormField labelText={SAML_LABELS[SAML_DOMAIN]} inputId={SAML_DOMAIN}>
      <InputField id={SAML_DOMAIN} name={SAML_DOMAIN} placeholder="Example: example.com" />
    </FormField>

    <FormField
      labelText={SAML_LABELS[SAML_METADATA]}
      inputId={SAML_METADATA}
      helpText="Typically generated by your identity provider. Copy and paste it here."
    >
      <TextAreaField
        id={SAML_METADATA}
        name={SAML_METADATA}
        // @ts-ignore
        rows={6}
      />
    </FormField>
  </GreyContainer>
);
